var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.adminTotpSetupStep }, [
    _c("div", { class: _vm.$style.numberContainer }, [
      _c(
        "div",
        {
          class: _vm.$style.numberContainerNumber,
          attrs: { "data-test-id": "adminTotpSetupStepNumber" },
        },
        [_vm._v("\n      " + _vm._s(_vm.number) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.contentContainer }, [
      _c(
        "h3",
        {
          class: _vm.$style.contentContainerTitle,
          attrs: { "data-test-id": "adminTotpSetupStepTitle" },
        },
        [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", [_vm._t("adminTotpSetupStepMessage")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }